import {Service} from '../../../service';

export class TaxCodeService extends Service {

  static get(taxCode) {
    return this.axios.get(`https://mst.minvoice.com.vn/api/System/SearchTaxCodeV2?tax=${taxCode}`).then(res => res.data);
  }

}